var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPadlock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "108px",
    height: "128px",
    viewBox: "0 0 108 128",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "7971951B-CAB7-49F7-99AE-7AAE1A51D811@1.00x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.37,32.87 L12.37,48.564 L7.421,48.564 C3.322,48.564 0,51.885 0,55.984 L0,55.984 L0,109.572 C0,113.675 3.325,117 7.427,117 L7.427,117 L82.58,117 C86.678,117 89.999,113.678 89.999,109.579 L89.999,109.579 L89.999,55.991 C89.999,51.888 86.675,48.564 82.572,48.564 L82.572,48.564 L78.055,48.564 L78.055,32.87 C78.055,14.745 63.32,0 45.212,0 L45.212,0 C27.105,0 12.37,14.745 12.37,32.87 L12.37,32.87 Z M16.823,32.87 C16.823,17.202 29.558,4.456 45.212,4.456 L45.212,4.456 C60.865,4.456 73.602,17.202 73.602,32.87 L73.602,32.87 L73.602,48.564 L66.181,48.564 L66.181,32.87 C66.181,21.3 56.774,11.884 45.212,11.884 L45.212,11.884 C33.651,11.884 24.244,21.3 24.244,32.87 L24.244,32.87 L24.244,48.564 L16.823,48.564 L16.823,32.87 Z M28.696,32.87 C28.696,23.755 36.105,16.341 45.212,16.341 L45.212,16.341 C54.32,16.341 61.728,23.755 61.728,32.87 L61.728,32.87 L61.728,48.564 L28.696,48.564 L28.696,32.87 Z M4.453,109.577 L4.453,55.992 C4.453,54.352 5.783,53.021 7.424,53.021 L7.424,53.021 L12.37,53.021 L28.696,53.021 L78.055,53.021 L82.58,53.021 C84.219,53.021 85.547,54.351 85.547,55.99 L85.547,55.99 L85.547,109.574 C85.547,111.214 84.217,112.545 82.577,112.545 L82.577,112.545 L7.421,112.545 C5.781,112.545 4.453,111.215 4.453,109.577 L4.453,109.577 Z M33.247,77.574 C33.247,80.316 34.182,82.904 35.869,84.977 L35.869,84.977 L34.364,97.044 L33.738,102.051 L38.78,102.051 L51.218,102.051 L56.258,102.051 L55.633,97.044 L54.126,84.977 C55.816,82.902 56.75,80.316 56.75,77.574 L56.75,77.574 C56.751,71.089 51.48,65.812 44.999,65.812 L44.999,65.812 C38.519,65.812 33.247,71.089 33.247,77.574 L33.247,77.574 Z M40.557,83.363 C38.823,82.027 37.701,79.931 37.701,77.574 L37.701,77.574 C37.701,73.54 40.968,70.269 44.999,70.269 L44.999,70.269 C49.029,70.269 52.299,73.54 52.299,77.574 L52.299,77.574 C52.299,79.933 51.174,82.027 49.439,83.363 L49.439,83.363 L51.218,97.595 L38.782,97.595 L40.557,83.363 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "J1---Onboarding/Migration",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Create-password---Web",
    transform: "translate(-935.000000, -342.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(877.000000, 342.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(58.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.4147,53.0458 L77.8837,53.0338 L61.5367,52.9888 L28.4607,52.8998 L12.1137,52.8558 L7.1577,52.841791 C5.5197,52.8378 4.1817,54.1658 4.1777,55.8058 L4.03268596,109.3868 C4.0277,111.0258 5.3587,112.3608 6.9967,112.3658 L82.2537,112.568809 C83.8917,112.5728 85.2287,111.2458 85.2337,109.6068 L85.378709,56.0248 C85.3827,54.3848 84.0517,53.0498 82.4147,53.0458 L82.4147,53.0458 Z M24.1017,48.4808 L16.6807,48.4608 L16.7237,32.7678 C16.7657,17.0998 29.5357,4.3888 45.1887,4.43069622 C60.8427,4.4728 73.5447,17.2538 73.5028038,32.9208 L73.4597,48.6138 L66.0387,48.5938 L66.0817,32.9008 C66.1127,21.3308 56.7317,11.8898 45.1687,11.8578 C33.6087,11.8268 24.1757,21.2168 24.1437,32.7878 L24.1017,48.4808 Z",
    id: "Fill-1",
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-4"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fill: "#020203",
    mask: "url(#mask-2)",
    points: "-5 122 95 122 95 -5 -5 -5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M51.2145,97.6015 L38.7785,97.6015 L40.5545,83.3705 C38.8185,82.0335 37.6965,79.9385 37.6965,77.5805 C37.6965,73.5465 40.9645,70.2755 44.9965,70.2755 C49.0255,70.2755 52.2955,73.5465 52.2955,77.5805 C52.2955,79.9405 51.1715,82.0335 49.4365,83.3705 L51.2145,97.6015 Z",
    id: "Fill-6",
    fill: "#227A64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6-Copy",
    transform: "translate(69.000000, 89.000000)",
    fill: "#DFDFDF",
    stroke: "#000000",
    strokeWidth: 4.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 18,
    cy: 18,
    r: 18
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-7-Copy",
    transform: "translate(77.000000, 101.000000)",
    stroke: "#227A64",
    strokeLinecap: "round",
    strokeWidth: 4.3384
  }, /*#__PURE__*/React.createElement("line", {
    x1: 1.21236354e-13,
    y1: 6.37860781,
    x2: 6.23333333,
    y2: 12.7572156,
    id: "Line"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.23333333,
    y1: 12.7572156,
    x2: 18.7,
    y2: 1.0658141e-14,
    id: "Line"
  })), /*#__PURE__*/React.createElement("path", {
    d: "",
    id: "Path-5",
    stroke: "#979797"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlock);
export default __webpack_public_path__ + "static/media/padlock.be6d00580d332f2d7b40bc21f09a1616.svg";
export { ForwardRef as ReactComponent };